import _ from 'lodash';
import { action } from 'typesafe-actions';
import * as actionTypes from 'constants/action-types';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { ApplicationState } from 'store/rootReducer';
import { AnyAction } from 'redux';
import { pollTrackingService } from 'axios/axios-polling';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import { ToastType } from 'store/ui/toasts/toastsTypes';
import i18n from 'i18n';
import { GenericDsl } from 'types/rest/dslTypes';

export const toggleModal = () => action(actionTypes.TOGGLE_MODAL);

export const appendDSL = (dsl: GenericDsl) => {
  return {
    type: actionTypes.APPEND_DSL_TO_ARRAY,
    payload: dsl,
  };
};

export const resetStoreState = () => {
  return {
    type: actionTypes.RESET_STORE_STATE,
  };
};

export const startUploadTrackingThunk = (
  trackingId: string,
  fileName: string,
  successToast?: any,
  errorToast?: any,
): ThunkAction<any, ApplicationState, null, AnyAction> => {
  return async (dispatch: ThunkDispatch<ApplicationState, any, AnyAction>): Promise<void> => {
    return new Promise<void>(async (resolve, reject) => {
      let errorMsg;

      try {
        // Poll for up to ~10 minutes
        // until the asset is saved
        const trackingResult = await pollTrackingService(trackingId, 120, 5000);
        errorMsg = _.get(trackingResult, 'data.result.errors');

        // Check if there is an error in the result
        if (!_.isEmpty(errorMsg)) {
          throw new Error('Cannot process uploaded file.');
        }

        // Show success toast
        const toastContent = successToast
          ? successToast
          : i18n.t('transactionsDropzone:successMsgs.fileProcessed', {
              filename: fileName,
            });
        const successToastNotification = showToastNotification(ToastType.Success, '', toastContent);
        dispatch(successToastNotification);

        // Resolve promise
        resolve();
      } catch (error) {
        const errorBody = i18n.t('transactionsDropzone:errorMsgs.uploadProcessingFailedForFile', {
          filename: fileName,
          errorReason: errorMsg ? errorMsg.toString() : '', //toString() is here because errorMsg can be array of strings
        });

        const errorToastBody = errorToast
          ? errorToast
          : i18n.t('transactionsDropzone:errorMsgs.uploadProcessingFailed');

        const dangerToastNotification = showToastNotification(ToastType.Danger, errorToastBody, errorBody);
        dispatch(dangerToastNotification);
        reject();
      }
    });
  };
};
